module.exports = __webpack_public_path__ + "img/gameProjectWhite.b32edb2d.svg";